/* eslint react/no-render-return-value: 0 */
import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Render a modal in the page through a temporary placeholder.
 *
 * @param {React.ReactElement} modal UXCore2 Modal.
 * @param {String} market Locale.
 * @param {Object} messages Internationalization data.
 * @param {Function} done Optional completion callback.
 * @returns {ReactDOM} Instance of internationalized modal.
 * @api public
 */
export function render(modal, market, messages, done = () => {}) {
  const placeholder = document.createElement('div');
  document.body.appendChild(placeholder);

  // attempts to render the 2200 version of modal
  const modalComponent = typeof modal === 'function' ? modal({ messages, portalElem: placeholder }) : React.cloneElement(modal, { messages });

  // check to see if 2200 actually rendered
  if (placeholder.children.length) {
    return done();
  }

  // did not render 2200 so we need to put it in outselves
  // TODO: change to react18's createRoot. https://godaddy-corp.atlassian.net/browse/UXP-9731
  // eslint-disable-next-line react/no-deprecated
  return ReactDOM.render(
    modalComponent,
    placeholder,
    done
  );
}
